// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__op6Wd","palette":"styles_palette__cZdsQ","button":"styles_button__-f98z"};